import { PipeTransform } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TypedFormControl } from 'osn-shared';
import { ErrorIfMissingPipe } from './error-if-missing.pipe';

export abstract class AbstractMissingPromptPipe implements PipeTransform {
  protected abstract readonly promptText: string;

  protected constructor(protected readonly errorIfMissingPipe: ErrorIfMissingPipe) {}

  public transform(value: UntypedFormControl | TypedFormControl<unknown>): string | undefined {
    return this.errorIfMissingPipe.transform(value, this.promptText);
  }
}
